import IntersectionHydrator from '@lib/hydrator';
import { registrations } from '../registrations';
new IntersectionHydrator(registrations);
